import * as React from 'react';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { ModelData } from 'src/containers/ProjectDiagram/types/model';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { createDraftData } from 'src/containers/ProjectDiagram/utils/draft/createDraftData';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const useInitializeDraftData = () => {
  const diagram = useDiagram();

  return React.useCallback(() => {
    if (!diagram) {
      return;
    }

    if (!diagram.model.modelData.draftData) {
      diagram.undoManager.clear();

      commitDiagramModel(diagram, (model) => {
        const draftData = createDraftData(model);
        setDataProperty<ModelData>(model)(
          model.modelData,
          'draftData',
          draftData
        );
      });
    }
  }, [diagram]);
};
